export enum SWAP_FORM_INPUTS {
  INPUT_A = 'input',
  INPUT_B = 'output',
}
